import * as React from 'react';
import { Button } from '@/hen-ui/atomics/Button';
import { Icon } from '@/hen-ui/atomics/Icon';
import type { ComparisonEmptySlot } from '../types';

export const EmptySlotHeader: React.FC<{
  slot: ComparisonEmptySlot;
}> = ({ slot }) => {
  if (!slot.onClick) return null;

  return (
    <Button
      type='button'
      aria-label={slot.ariaLabel ?? slot.label}
      onClick={slot.onClick}
      variant='textOnly'
      className='relative w-28 h-16 bg-white border border-neutral-200 border-dashed rounded-xs transition-colors [&_svg]:w-9 [&_svg]:h-9 cursor-pointer hover:bg-neutral-50 focus-visible:ring-2 focus-visible:ring-primary-700 focus-visible:ring-offset-2'
    >
      <Icon icon='circle-plus' />
    </Button>
  );
};

EmptySlotHeader.displayName = 'EmptySlotHeader';
